 import CryptoJS from 'crypto-js/crypto-js'
import {randomString} from './util'
import JSEncrypt from './jsencrypt.min'

/**
 * @return {string}
 */
export function getAesKey() {
  return randomString()
}

export function aesEncrypt(word, key) {
  const kk = CryptoJS.enc.Utf8.parse(key)
  const iv = CryptoJS.enc.Utf8.parse(key)

  let srcs = CryptoJS.enc.Utf8.parse(word);
  let encrypted = CryptoJS.AES.encrypt(srcs, kk, {
    iv: iv,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.ZeroPadding
  })

  return CryptoJS.enc.Base64.stringify(encrypted.ciphertext);
}

export function rsaEncrypt(word, key) {
  const ee = new JSEncrypt()
  ee.setPublicKey(key)
  return ee.encrypt(word)
}